import {
    FETCH_PRODUCTS_SUCCESS,
    FETCH_PRODUCT_BY_ID_SUCCESS,

    PRODUCTS_REQUEST_LOADING,
    PRODUCTS_REQUEST_ERRORS
} from "api/menu/master-files/product-maintenance/actions";

const initialState = {
    loading: false,
    errors: [],

    products: [],
    singleProduct: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PRODUCTS_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case PRODUCTS_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_PRODUCTS_SUCCESS:
            return {
                ...state,
                loading: false,
                products: action.payload
            };
        case FETCH_PRODUCT_BY_ID_SUCCESS:
            return {
                ...state,
                errors: [],
                loading: false,
                singleProduct: action.payload
            };
        default:
            return state;
    }
}
